<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="tips">
          <el-page-header
            @back="goBack"
            content="徒弟基本信息"
          ></el-page-header>
        </div>
      </div>
    </div>

    <div class="uc-userEdit">
      <div class="container bg-white">
        <!-- 徒弟信息 -->
        <div class="row">
          <div class="col-24">
            <div class="form">
              <div class="user-box">
                <div class="face">
                  <img
                    :src="model.apprentice_avatar"
                    :alt="model.apprentice_name"
                    onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                  />
                </div>
              </div>
              <div class="list">
                <div class="item">
                  <div class="txt">徒弟姓名</div>
                  <div class="con">
                    {{ model.apprentice_name }} ·
                    {{ model.apprentice_username }}
                  </div>
                </div>
                <div class="item">
                  <div class="txt">所属部门</div>
                  <div class="con">
                    {{ model.apprentice_org }}
                  </div>
                </div>
                <div class="item">
                  <div class="txt">师徒期限</div>
                  <div class="con">{{ model.limit_time }} 个月</div>
                </div>
                <div class="item">
                  <div class="txt">关系开始</div>
                  <div class="con">
                    {{ model.start_time }}
                  </div>
                </div>
                <div class="item" v-if="model.status !== 1">
                  <div class="txt">关系结束</div>
                  <div class="con">{{ model.end_time }}</div>
                </div>
                <div class="item">
                  <div class="txt">关系状态</div>
                  <div class="con">
                    <el-tag
                      v-if="model.status == 1"
                      type="success"
                      size="small"
                    >
                      {{ model.status_text }}
                    </el-tag>
                    <el-tag v-else type="warning" size="small">
                      {{ model.status_text }}
                    </el-tag>
                  </div>
                </div>
                <div class="item">
                  <div class="txt">日志</div>
                  <div class="con">
                    <router-link
                      :to="{
                        name: 'ShituMasterLog',
                        params: { id: model.apprentice_id },
                      }"
                    >
                      查看（{{ model.log_count }}）
                    </router-link>
                  </div>
                </div>
                <div class="item">
                  <div class="txt">沟通</div>
                  <div class="con">
                    <router-link
                      :to="{
                        name: 'ShituMasterCommunication',
                        params: { id: model.apprentice_id },
                      }"
                    >
                      查看（{{ model.communication_count }}）
                    </router-link>
                  </div>
                </div>
                <div class="item">
                  <div class="txt">任务</div>
                  <div class="con">
                    <router-link
                      :to="{
                        name: 'ShituMasterApprenticeTask',
                        params: { id: model.apprentice_id },
                      }"
                    >
                      查看（{{ model.task_count }}）
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /徒弟信息 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MasterApprenticeDetails',
  data() {
    return {
      query: { id: this.$route.params.id },
      model: {},
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getApprenticeDetails();
    },
    async getApprenticeDetails() {
      const response = await this.$api.shitu.GetApprenticeDetails(this.query);
      this.model = response.data.data;
    },
    // 返回上一层
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
